// extracted by mini-css-extract-plugin
export var avatarContainer = "_6l-0";
export var avatarTypingWave = "_6l-i";
export var gray = "_6l-f";
export var green = "_6l-c";
export var icon = "_6l-9";
export var image = "_6l-1";
export var lg = "_6l-6";
export var md = "_6l-5";
export var presenceDot = "_6l-b";
export var red = "_6l-d";
export var sm = "_6l-4";
export var status = "_6l-a";
export var typingDot = "_6l-h";
export var typingPill = "_6l-g";
export var xl = "_6l-7";
export var xs = "_6l-3";
export var xxl = "_6l-8";
export var xxs = "_6l-2";
export var yellow = "_6l-e";